import React, {useEffect, useState, useRef} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useParams, useNavigate} from "react-router-dom";
import {Button, ButtonGroup} from 'react-bootstrap';
import NameCase from "namecase";

import {
    DollarSignIcon, NewMessageIcon, TrashCanIcon, CheckBoxIcon, SendIcon,
} from "../../Components/Icons";
import {
    deleteUserData, markNotADuplicate, getAllUsers, redirectPayUserForAdminLookup, getPayerUserById, getAdminUserData
} from "../../Actions/authActions";
import Table from "./../AdminDashboard/ReactTable/ReactTableMain";
import { subDomain, amountFormatterWithZero, saveLogRocketSession } from "../../utils";
import sumBy from "lodash/sumBy";
import map from "lodash/map";
import CustomPopoverDelete from "../../Components/CustomPopoverDelete";
import CustomePopUp from "../../Components/customePopUp";
import {DELETE_USERDATA_INITIAL, FETCH_GETALL_DATA_SUCCESS} from "../../constants";
import "./payersTable.css";
import SendIntakeFormModal from "../../Components/SendIntakeFormModal";
import ReactTableServerSide from "./ReactTable/ReactTableServerSide";
import DuplicateHistory from "./DuplicateHistory";
import axios from "axios";
import {executeGet} from "../../Api";

const PayersTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [searchTerm, setSearchTerm] = useState('');
    const isMountedRef = useRef(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const userAdmin = props.userAdmin;
    const {themeColor1} = props || "";
    const {match} = props || {};
    const params = useParams();
    const subdomain = params.subdomain || subDomain();

    const user = useSelector((state) => state.auth.alluser);
    const [userData, setUserData] = useState(user);
    const alluserTotalPages = useSelector((state) => state.auth.alluserTotalPages);
    const alluserTotalCount = useSelector((state) => state.auth.alluserTotalCount);
    const alluserSearchResultCount = useSelector((state) => state.auth.alluserSearchResultCount);
    const alluserSearchResultPages = useSelector((state) => state.auth.alluserSearchResultPages);


    const [showPopUpDelete, setShowPopUpDelete] = useState(false);
    const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
    const [showErrorPopUp, setShowErrorPopUp] = useState(false);
    const [payerForDeletion, setPayerForDeletion] = useState({});
    const [payerForDeletionTotal, setPayerForDeletionTotal] = useState("0.00");
    const [tablePropsForDeletion, setTablePropsForDeletion] = useState(null);
    const [showPayersWithDups, setShowPayersWithDups] = useState(false);
    const [duplicateErrorsCount, setDuplicateErrorsCount] = useState(0);
    const [duplicateDismissedCount, setDuplicateDismissedCount] = useState(0);

    const [isSendOpen, setIsSendOpen] = useState(false);
    const [intakeFormToSend, setIntakeFormToSend] = useState({});
    const [selectedPayer, setSelectedPayer] = useState(null);

    const deleteUserDataLoading = useSelector((state) => state.auth.deleteUserDataLoading);
    const deleteUserDataSuccess = useSelector((state) => state.auth.deleteUserDataSuccess)
    const deleteUserDataError = useSelector((state) => state.auth.deleteUserDataError)


    // const [showOptionalColumns, setShowOptionalColumns] = useState(localStorage.getItem("showOptionalColumns") === "true");


    const adminUser = useSelector(state => state.auth.adminUser);
    const intakeforms = useSelector((state) => state.auth.adminUser.intakeforms);

    // Cleanup function to prevent state updates on unmounted component
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (adminUser && !Object.keys(adminUser).length) {
            dispatch(getAdminUserData(subdomain));
            // dispatch(getMessage(subdomain));
            // dispatch(getUserforms(subdomain));
        }
    }, [!adminUser]);


    useEffect(() => {
        if (deleteUserDataSuccess) {
            setShowPopUpDelete(false);
            setShowSuccessPopUp(true);
        }
        if (deleteUserDataError) {
            setShowPopUpDelete(false);
            setShowErrorPopUp(true);
        }
    }, [deleteUserDataSuccess, deleteUserDataError]);

    const fetchUsers = async ({currentPage, limit, sortBy, sortDirection, searchTerm, searchBy}) => {
        try {
            const buildQuery = {
                subdomain: subdomain,
                page: currentPage,
                limit,
                sortBy,
                sortDirection,
                searchTerm,
                searchBy,
            };
            const url = `users/allUsers?${new URLSearchParams(buildQuery).toString()}`;
            const result = await executeGet(url, {})
                .then((res) => {
                    const {data} = res || {};
                    return data;
                });

            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setDuplicateErrorsCount(result.duplicateErrorsCount || 0);
                setDuplicateDismissedCount(result.duplicateDismissedCount || 0);
            }

            return {
                data: result.users,
                total: result.totalCount,
                totalPages: result.totalPages,
                currentPage: result.page,
                pageSize: result.pageSize,
            };
        } catch (error) {
            console.error("Error fetching data:", error);
            saveLogRocketSession({ eventType: "payers_fetch_error", metadata: { error: String(error) } });
            // total: null (not 0) so the table never shows "No open duplicate errors." for a failed fetch
            return {data: [], total: null};
        }
    };


    useEffect(() => {
        setUserData(user);
    }, [user]);

    // useEffect(() => {
    //     const isDuplicateErrors = userData && userData.length > 0 && userData.some(user => user.hasDuplicateErr === true);
    //     setSomeHasDuplicateErr(isDuplicateErrors || false);
    // }, [userData]);

    const handleDelete = (row, tableProps) => {
        setTablePropsForDeletion(tableProps);
        setShowPopUpDelete(true);
        setPayerForDeletion(row);
        setPayerForDeletionTotal(amountFormatterWithZero(totalAmounts(row)));
    }

    const handleMarkNotADuplicate = (row, tableProps) => {
        dispatch(markNotADuplicate(row.id || row._id, subdomain));
    }

    const handlePay = (row) => {
        dispatch(getPayerUserById({subdomain: subdomain, id: row.id}));
        dispatch(redirectPayUserForAdminLookup(row, subdomain, navigate));
    }

    const deletePayer = (payerForDeletion) => {
        dispatch(deleteUserData(payerForDeletion._id, subdomain));
    };


    const handleClosePopUp = () => {
        setShowPopUpDelete(false);
        setPayerForDeletion({});
        setPayerForDeletionTotal("0.00");
        setTablePropsForDeletion(null);
    }

    const handleSuccessClosePopUp = () => {
        setShowSuccessPopUp(false);

        const dataCopy = [...userData];
        dataCopy.splice(tablePropsForDeletion, 1);
        setUserData(dataCopy);
        setPayerForDeletion({});
        setPayerForDeletionTotal("0.00");
        setTablePropsForDeletion(null);
        dispatch({type: DELETE_USERDATA_INITIAL});
    }

    const handleErrorClosePopUp = () => {
        setShowErrorPopUp(false);
        dispatch({type: DELETE_USERDATA_INITIAL});
    }

    const toggleShowPayersWithDuplicateErrors = () => {
        setShowPayersWithDups(!showPayersWithDups);
    }

    const toggleShowAllColumns = () => {
        setShowOptionalColumns(!showOptionalColumns);
        localStorage.setItem("showOptionalColumns", (!showOptionalColumns).toString());
    }

    const totalAmounts = (row) => {
        return sumBy(map(row.patientPayer, (i) => ({
            ...i, accountBalance: parseFloat(i.accountBalance) || 0,
        })), "accountBalance");
    };

    const displayPatientPayers = (row, property) => {

        return (row.patientPayer.map((v, i) => {
            let displayText = "";
            if (property === "patientFirst") {
                displayText = NameCase(`${v.patientFirst} ${v.patientMiddle}`);
            } else if (property === "patientLast") {
                displayText = NameCase(`${v.patientLast}`);
            } else if (property === "accountBalance") {
                displayText = `$${amountFormatterWithZero(v[property])}`;
            } else if (property === "patientEmail") {
                displayText = (v[property] || '').toLowerCase();
            } else {
                displayText = v[property];
            }
            const cellAlignment = property === 'accountBalance' ? {textAlign: 'center'} : {};
            return (<table
                style={{
                    tableLayout: "fixed", width: "100%",
                }}
                key={i}
            >
                <tbody>

                <tr style={{width: "100%"}}>
                    <td style={{
                        width: "100%",
                        ...cellAlignment,
                    }}>{displayText}</td>
                </tr>
                </tbody>
            </table>)
        }))
    };

    const actionsTable = (props, tableProps, showPayersWithDups) => {

        return (<>
            {/*<table>*/}
            {/*<tbody>*/}
            {/*<tr  style={{width: "6vw"}}>*/}
            <div style={{display: "flex", justifyContent: "space-around"}} key={props.row.id}>
                {!showPayersWithDups && <>
                    <div
                        className="text-center"
                        style={{
                            cursor: "pointer", backgroundColor: "inherit",
                        }}
                        onClick={() => {
                            setSelectedPayer(props.row.original);
                            setIsSendOpen(true);
                        }}
                    >
                        <SendIcon color={themeColor1} height="1.4vw" width="1.4vw"/>
                        <div>Send Form</div>
                    </div>
                    <div
                        className='text-center'
                        style={{
                            cursor: "pointer", backgroundColor: "inherit", paddingRight: "0.2vw"
                        }}
                        onClick={() => handlePay(props.row.original)}
                    >
                        <DollarSignIcon color={themeColor1} height={"1.4vw"}/>
                        <div>Payment</div>
                    </div>
                    <div
                        className="text-center"
                        style={{
                            cursor: "pointer", backgroundColor: "inherit",
                        }}
                        onClick={() => handleDelete(props.row.original, tableProps)}
                    >
                        <TrashCanIcon color={themeColor1} height={"1.4vw"}/>
                        <div>Delete</div>
                    </div>
                </>}
                {showPayersWithDups && props.row.original.duplicateDismissedAt && <div className="text-center">
                    <span className="badge bg-secondary">Dismissed</span>
                    <div className="small text-muted">{new Date(props.row.original.duplicateDismissedAt).toLocaleDateString()}</div>
                    {props.row.original.duplicateErrTimeStamp
                        && new Date(props.row.original.duplicateErrTimeStamp) > new Date(props.row.original.duplicateDismissedAt)
                        && <div className="small text-muted">still arriving {new Date(props.row.original.duplicateErrTimeStamp).toLocaleDateString()}</div>}
                </div>}
                {showPayersWithDups && !props.row.original.duplicateDismissedAt && <div
                    className="text-center"
                    style={{
                        cursor: "pointer", backgroundColor: "inherit",
                    }}
                    onClick={() => handleMarkNotADuplicate(props.row.original, tableProps)}
                >
                    {/*<TrashCanIcon color={themeColor1} height={"1.4vw"}/>*/}
                    <CheckBoxIcon color={themeColor1} height={"1.4vw"} width={"1.4vw"}/>
                    <div>Dismiss</div>

                </div>}
            </div>
            {/*</tbody>*/}
            {/*</table>*/}
        </>)
    }

    // const columns = [{accessorKey: "id", header: "ID"}, {accessorKey: "Payer Name", header: "Payer Name"}, {
    //     accessorKey: "email",
    //     header: "Email"
    // }, {accessorKey: "phone", header: "Phone"},];


    function convertToTitleCase(str) {
        if (!str) {
            return "";
        }
        return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
    }

    const columnSizes = {
        payerFirst: 50,
        payerLast: 100,
        payerId: 50,
        payerEmail: 100,
        payerCell: 100,
        xmlPayerFirst: 50,
        xmlPayerLast: 50,
        xmlPayerId: 50,
        xmlPayerEmail: 100,
        xmlPayerCell: 100,
        totalAmounts: 70,
        patientNumber: 50,
        patientFirst: 50,
        patientLast: 100,
        patientEmail: 100,
        patientCell: 100,
        accountBalance: 70,
        actions: 100,
    };

    const columns = React.useMemo(() => {

        const dupsTableColumns = [

            {
                id: "payerFirst",
                header: "First",
                enableSorting: true,
                accessorKey: "payerFirst",
                cell: (props) => NameCase(`${props.row.original.payerFirst} ${props.row.original.payerMiddle}`),
                size: columnSizes['payerFirst'],
                minSize: columnSizes['payerFirst'],
                maxSize: columnSizes['payerFirst'],
            },
            {
                id: "payerLast",
                header: "Last",
                enableSorting: true,
                accessorKey: "payerLast",
                cell: (props) => NameCase(`${props.row.original.payerLast}`),
                size: columnSizes['payerLast'],
                minSize: columnSizes['payerLast'],
                maxSize: columnSizes['payerLast'],

            },
            {
                id: "payerId",
                header: "Payer ID",
                enableSorting: true,
                accessorKey: "payerId",
                cell: (props) => props.row.original.payerId,
                size: columnSizes['payerId'],
                minSize: columnSizes['payerId'],
                maxSize: columnSizes['payerId'],
            },
            {
                id: "payerEmail",
                header: "Payer Email",
                enableSorting: true,
                accessorKey: "payerEmail",
                cell: (props) => props.row.original.payerEmail && props.row.original.payerEmail.startsWith("*fake*") ? "" : (props.row.original.payerEmail || ""),
                size: columnSizes['payerEmail'],
                minSize: columnSizes['payerEmail'],
                maxSize: columnSizes['payerEmail'],
            },
            {
                id: "payerCell",
                header: "Payer Cell",
                enableSorting: true,
                accessorKey: "payerCell",
                cell: (props) => props.row.original.payerCell && props.row.original.payerCell.startsWith("*fake*") ? "" : (props.row.original.payerCell || ""),
                size: columnSizes['payerCell'],
                minSize: columnSizes['payerCell'],
                maxSize: columnSizes['payerCell'],
            },
            // {
            //     id: "payerCell",
            //     header: "Conflicting Contact Info",
            //     enableSorting: true,
            //     accessorKey: "duplicateReferenceObj.conflictingInfo",
            //     cell: (props) => props.row.original.duplicateReferenceObj?.conflictingInfo === 'payerCell' ? "Payer Cell": "Payer Email",
            //     size: columnSizes['conflictingInfo'],
            //     minSize: columnSizes['conflictingInfo'],
            //     maxSize: columnSizes['conflictingInfo'],
            // },

            {
                id: "xmlPayerFirst",
                header:
                    "Payer First", enableSorting:
                    true,
                accessorKey:
                    "duplicateReferenceObj.xmlPayerFirst",
                cell: (props) => NameCase(`${props.row.original?.duplicateReferenceObj?.xmlPayerFirst || ''} ${props.row.original?.duplicateReferenceObj?.xmlPayerMiddle || ''}`),
                size: columnSizes['xmlPayerFirst'],
                minSize: columnSizes['xmlPayerFirst'],
                maxSize: columnSizes['xmlPayerFirst'],
            },
            {
                id: "xmlPayerLast",
                header:
                    "Payer Last", enableSorting:
                    true,
                accessorKey:
                    "duplicateReferenceObj.xmlPayerLast",
                size: columnSizes['xmlPayerLast'],
                minSize: columnSizes['xmlPayerLast'],
                maxSize: columnSizes['xmlPayerLast'],
            },
            {
                id: "xmlPayerId",
                header:
                    "Payer ID", enableSorting:
                    true,
                accessorKey:
                    "duplicateReferenceObj.xmlPayerId",
                size: columnSizes['xmlPayerId'],
                minSize: columnSizes['xmlPayerId'],
                maxSize: columnSizes['xmlPayerId'],
            },
            {
                id: "xmlPayerEmail",
                header: "Payer Email",
                enableSorting: true,
                accessorKey: "duplicateReferenceObj.xmlPayerEmail",
                cell: (props) => props.row.original.duplicateReferenceObj?.xmlPayerEmail || '',
                size: columnSizes['xmlPayerEmail'],
                minSize: columnSizes['xmlPayerEmail'],
                maxSize: columnSizes['xmlPayerEmail'],
            },
            {
                id: "xmlPayerCell",
                header:
                    "Payer Cell",
                enableSorting: true,
                accessorKey: "duplicateReferenceObj.xmlPayerCell",
                cell: (props) => props.row.original.duplicateReferenceObj?.xmlPayerCell || '',
                size: columnSizes['xmlPayerCell'],
                minSize: columnSizes['xmlPayerCell'],
                maxSize: columnSizes['xmlPayerCell'],
            },
            {
                id: "actions",
                header: "Actions",
                colStyle: {
                    "textAlign": "center"
                }
                , enableSorting: false,
                enableColumnFilter: false,
                accessorFn:
                    row => row.id,
                cell: (props, tableProps) => (actionsTable(props, tableProps, showPayersWithDups)),
                size: columnSizes['actions'],
                minSize: columnSizes['actions'],
                maxSize: columnSizes['actions'],
            }
        ];

        const mainTableColumns = [
            {
                id: "payerFirst",
                header: "First",
                enableSorting: true,
                accessorKey: "payerFirst",
                cell: (props) => NameCase(`${props.row.original.payerFirst} ${props.row.original.payerMiddle}`),
                size: columnSizes['payerFirst'],
                minSize: columnSizes['payerFirst'],
                maxSize: columnSizes['payerFirst'],
            },
            {
                id: "payerLast",
                header: "Last",
                enableSorting: true,
                accessorKey: "payerLast",
                cell: (props) => NameCase(`${props.row.original.payerLast}`),
                size: columnSizes['payerLast'],
                minSize: columnSizes['payerLast'],
                maxSize: columnSizes['payerLast'],

            },
            {
                id: "payerId",
                header: "Payer ID",
                enableSorting: true,
                accessorKey: "payerId",
                size: columnSizes['payerId'],
                minSize: columnSizes['payerId'],
                maxSize: columnSizes['payerId'],
            },
            {
                id: "payerEmail",
                header: "Payer Email",
                enableSorting: true,
                accessorKey: "payerEmail",
                cell: (props) => props.row.original.payerEmail && props.row.original.payerEmail.startsWith("*fake*") ? "" : (props.row.original.payerEmail || ""),
                size: columnSizes['payerEmail'],
                minSize: columnSizes['payerEmail'],
                maxSize: columnSizes['payerEmail'],
            },
            {
                id: "payerCell",
                header: "Payer Cell",
                enableSorting: true,
                accessorKey: "payerCell",
                cell: (props) => props.row.original.payerCell && props.row.original.payerCell.startsWith("*fake*") ? "" : (props.row.original.payerCell || ""),
                size: columnSizes['payerCell'],
                minSize: columnSizes['payerCell'],
                maxSize: columnSizes['payerCell'],
            },
            {
                id: "totalAmounts",
                header: "Total Due",
                enableSorting: false,
                enableColumnFilter: false,
                accessorKey: "totalAmounts",
                cell: (props) => <div
                    style={{textAlign: 'center'}}>${amountFormatterWithZero(props.row.original.totalAmounts)}</div>,
                size: columnSizes['totalAmounts'],
                minSize: columnSizes['totalAmounts'],
                maxSize: columnSizes['totalAmounts'],

            },
            {
                id: "patientNumber",
                header: "Patient Number",
                enableSorting: false,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.patientNumber).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "patientNumber"),
                size: columnSizes['patientNumber'],
                minSize: columnSizes['patientNumber'],
                maxSize: columnSizes['patientNumber'],

            },
            {
                id: "patientFirst",
                header: "Patient First",
                enableSorting: false,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => `${ptPayer.patientFirst}`).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "patientFirst"),
                size: columnSizes['patientFirst'],
                minSize: columnSizes['patientFirst'],
                maxSize: columnSizes['patientFirst'],

            },
            {
                id: "patientLast",
                header: "Patient Last",
                enableSorting: false,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => `${ptPayer.patientLast}`).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "patientLast"),
                size: columnSizes['patientLast'],
                minSize: columnSizes['patientLast'],
                maxSize: columnSizes['patientLast'],

            },
            {
                id: "patientEmail",
                header: "Patient Email",
                enableSorting: false,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.patientEmail).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "patientEmail"),
                size: columnSizes['patientEmail'],
                minSize: columnSizes['patientEmail'],
                maxSize: columnSizes['patientEmail'],

            },
            {
                id: "patientCell",
                header: "Patient cell",
                enableSorting: false,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.patientcell).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "patientCell"),
                size: columnSizes['patientCell'],
                minSize: columnSizes['patientCell'],
                maxSize: columnSizes['patientCell'],

            },
            {
                id: 'accountBalance',
                header: "Patient Amount",
                enableColumnFilter: false,
                enableSorting: true,
                accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.accountBalance).join("_"),
                cell: (props) => displayPatientPayers(props.row.original, "accountBalance"),
                size: columnSizes['accountBalance'],
                minSize: columnSizes['accountBalance'],
                maxSize: columnSizes['accountBalance'],

            },
            {
                id: "actions",
                header: "Actions",
                colStyle: {"textAlign": "center"},
                enableSorting: false,
                enableColumnFilter: false,
                accessorFn: row => row.id,
                cell: (props, tableProps) => (actionsTable(props, tableProps, showPayersWithDups)),
                size: columnSizes['actions'],
                minSize: columnSizes['actions'],
                maxSize: columnSizes['actions'],
            }
        ];

        if (showPayersWithDups) {
            return dupsTableColumns;
        }
        if (!showPayersWithDups) {
            return mainTableColumns;
        }
    }, [userData, showPayersWithDups]);


    return (<>
        <div className=" container-fluid">
            {showPopUpDelete && <CustomPopoverDelete
                title={"Delete Payer and Patients?"}
                subtext={"The following payer record with its associated patient records will be removed from the portal. " + "If these patients are associated with other payers, those records would remain associated with those payers."}
                show={showPopUpDelete}
                isLoading={deleteUserDataLoading}
                deletePayer={deletePayer}
                close={handleClosePopUp}
                displayPatientPayers={displayPatientPayers}
                payerForDeletion={payerForDeletion}
                payerForDeletionTotal={payerForDeletionTotal}
                themeColor1={themeColor1}
            />}
            {showSuccessPopUp ? (<CustomePopUp
                message={"Deletion successful"}
                openModal={showSuccessPopUp}
                onCloseModal={handleSuccessClosePopUp}
            />) : ""}

            {showErrorPopUp ? (<CustomePopUp
                message={"Error when deleting the payer"}
                openModal={showErrorPopUp}
                onCloseModal={handleErrorClosePopUp}
            />) : ""}

            {/*// className={`sos-custom-btn-new-message ${showPayersWithDups ? "sos-custom-btn-css" : "sos-secondary-btn-css"} mb-1 w-25 float-right`}*/}
            {/*// onClick={() => toggleShowPayersWithDuplicateErrors()}*/}

            {<ReactTableServerSide
                showSpecialFilterButton={true}
                isSpecialFilter={showPayersWithDups}
                setIsSpecialFilter={setShowPayersWithDups}
                specialFilterOnText={"Show All Payers"}
                specialFilterOffText={duplicateDismissedCount > 0
                    ? `Show Payers with Duplicate Errors (${duplicateErrorsCount - duplicateDismissedCount} open, ${duplicateDismissedCount} dismissed)`
                    : `Show Payers with Duplicate Errors (${duplicateErrorsCount})`}
                specialFilterHeadings={
                    [
                        { label: "Existing in portal", colSpan: 5 },
                        { label: "Attempted to add to portal", colSpan: 5 },
                        // { label: "", colSpan: 1 }, // empty label, no colspan needed but for uniformity
                    ]
                }
                tableColumnShadeBeginsAt={4}
                tableColumnShadeEndsAt={10}
                secondHalfOfTableBgColor={"#f0f8ff"}

                fetchData={fetchUsers}
                columns={columns}
                // searchPlaceholder='Search by Payer or Patient name, email, or cell'
                initialSortState={{sortBy: "payerLast", desc: false}}
                // currentPage={currentPage}
                // setCurrentPage={setCurrentPage}
                // limit={limit}
                // setLimit={setLimit}
                // searchTerm={searchTerm}
                // setSearchTerm={setSearchTerm}
                // // getSearchData={getSearchData}
                // data={showPayersWithDups ? userData.filter(user => user.hasDuplicateErr) : userData}
                // noDataMessage={"No data"}
            />}


            {/*{userData && <Table*/}
            {/*    currentPage={currentPage}*/}
            {/*    setCurrentPage={setCurrentPage}*/}
            {/*    limit={limit}*/}
            {/*    setLimit={setLimit}*/}
            {/*    searchTerm={searchTerm}*/}
            {/*    setSearchTerm={setSearchTerm}*/}
            {/*    // getSearchData={getSearchData}*/}
            {/*    columns={columns}*/}
            {/*    data={showPayersWithDups ? userData.filter(user => user.hasDuplicateErr) : userData}*/}
            {/*    noDataMessage={"No data"}*/}
            {/*/>}*/}
            {showPayersWithDups && <DuplicateHistory subdomain={subdomain} days={90}/>}

            {selectedPayer && <SendIntakeFormModal
                selectedPayer={selectedPayer}
                adminUser={adminUser}
                intakeFormToSend={intakeFormToSend}
                setIntakeFormToSend={setIntakeFormToSend}
                intakeforms={adminUser?.intakeforms}
                openModal={isSendOpen}
                onCloseModal={() => {
                    setSelectedPayer(null)
                    setIsSendOpen(false)
                }}
                subdomain={subdomain}
            />}
        </div>
    </>);
};
export default PayersTable;
